/**
 * Parse error messages from TRPC error responses or any other error format
 *
 * @param error The caught error object (unknown type)
 * @param fallbackMessage Optional fallback message if no error details can be extracted
 * @returns Array of error messages
 */
export const parseTRPCError = (error: unknown, fallbackErrorMessage: string) => {
    console.error('API error:', error);

    // Cast to an object with potential error structure
    const typedError = error as {
        data?: {
            errorMessages?: string[];
            zodError?: { message?: string };
        };
        message?: string;
        shape?: { message?: string };
    };

    const errorMessages: string[] = [];

    // Check for structured TRPC error messages
    if (typedError.data?.errorMessages?.length) {
        errorMessages.push(...typedError.data.errorMessages);
    }
    // Check for Zod validation errors
    else if (typedError.data?.zodError?.message) {
        errorMessages.push(typedError.data.zodError.message);
    }
    // Check for standard error message
    else if (typedError.message) {
        errorMessages.push(typedError.message);
    }
    // Check for shape message (sometimes TRPC puts it here)
    else if (typedError.shape?.message) {
        errorMessages.push(typedError.shape.message);
    }
    // Use fallback message if nothing else available
    else {
        errorMessages.push(fallbackErrorMessage);
    }

    return errorMessages;
};
